/* tslint:disable */
/* eslint-disable */
/**
 * Localingos API
 * Developer-first automated localization platform powered by AI. Sync your project and continuously localize only what changed.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Translation job status
 * @export
 * @enum {string}
 */

export const JobStatus = {
    Queued: 'QUEUED',
    InProgress: 'IN_PROGRESS',
    Failed: 'FAILED',
    Blocked: 'BLOCKED',
    Done: 'DONE',
    Canceled: 'CANCELED'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];



